import React, {useState} from "react";
import {useForm} from "react-hook-form";
import CategoryFields from "./CategoryFields";
import EditCategoryFields from "./EditCategoryFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const categoryFields = <CategoryFields {...{register, errors, control, data, watch}} />;
  const editCategoryFields = <EditCategoryFields {...{register, errors, control, data, watch}} />;

  return {
    setErrors,
    categoryFields,
    editCategoryFields,
    handleSubmit,
    setData,
    reset,
  }
}